import React from 'react';
import Icon from '../../../components/AppIcon';

const OfficeLocation = ({ city, address, phone, hours, isHeadquarters = false }) => {
  return (
    <div className={`bg-card rounded-lg p-6 border ${isHeadquarters ? 'border-primary' : 'border-border'} hover:shadow-md transition-all duration-300`}>
      {isHeadquarters && (
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold mb-4">
          <Icon name="Star" size={14} />
          Headquarters
        </div>
      )}
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        {city}
      </h3>
      <div className="space-y-3">
        <div className="flex items-start gap-3">
          <Icon name="MapPin" size={18} className="text-primary mt-1 flex-shrink-0" />
          <p className="text-sm text-muted-foreground leading-relaxed">
            {address}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Icon name="Phone" size={18} className="text-primary flex-shrink-0" />
          <a
            href={`tel:${phone}`}
            className="text-sm text-foreground hover:text-primary transition-colors duration-200 font-medium"
          >
            {phone}
          </a>
        </div>
        <div className="flex items-start gap-3">
          <Icon name="Clock" size={18} className="text-primary mt-1 flex-shrink-0" />
          <p className="text-sm text-muted-foreground">
            {hours}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfficeLocation;